import { render, staticRenderFns } from "./history.vue?vue&type=template&id=15596877&scoped=true"
import script from "./history.vue?vue&type=script&lang=js"
export * from "./history.vue?vue&type=script&lang=js"
import style0 from "../../../static/css/collection.css?vue&type=style&index=0&id=15596877&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15596877",
  null
  
)

export default component.exports